/**
 * Shared layout chrome for an action card's body.
 *
 * The padding + max-width + container-query offsets were copy-pasted across
 * every card (calendar, link, merge, merged-create, external, the shared
 * content wrapper), so widening the cards meant finding nine string literals
 * and hoping none were missed. One constant instead.
 *
 * The width cap exists so a card's diff columns stay readable rather than
 * stretching the full panel; 560px buys a diff column ~30px more than the
 * previous 500px, which is what a typical work email address needs before it
 * has to truncate.
 *
 * The body starts flush left, at the same x as the shell title and the email
 * card's "To:" line. It used to carry a `@xl:ml-[30px]` inset that indented
 * every card body under the header checkbox, which read as a second, unrelated
 * left edge inside the card.
 */
export const ACTION_CARD_BODY_CLASS = 'px-4 py-3 max-w-[560px]';
